import { FolderMessageContent } from '../../../models/communication.types';
import { getAttachment } from '../../../services/communication/communication.service';
import AttachmentBox from '../AttachmentBox/AttachmentBox.component';
import LinkBox from '../LinkBox.component';
import { useStyles } from './MessagePreviewBodyFooter.styles';

interface MessagePreviewBodyFooterProps {
  messageContent: FolderMessageContent;
}

const MessagePreviewBodyFooter: React.FC<MessagePreviewBodyFooterProps> = ({ messageContent }) => {
  const classes = useStyles();

  const handleDownload = () => {
    messageContent.attachmentName && getAttachment(messageContent.messageId, messageContent.attachmentName);
  };

  if (!messageContent.attachmentName && !messageContent.url) {
    return <></>;
  }

  return (
    <div className={classes.bodyFooter}>
      {messageContent.attachmentName && (
        <AttachmentBox
          fileName={messageContent.attachmentName}
          sizeInBytes={messageContent.attachmentSize ?? 0}
          onDownload={handleDownload}
        />
      )}
      {messageContent.url && <LinkBox url={messageContent.url} />}
    </div>
  );
};

export default MessagePreviewBodyFooter;
